module.exports = __webpack_public_path__ + "img/GCivil_AHerzog-1536x864.5fb9e66a.jpg";